<div id="layout-wrapper">
  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()"> </app-topbar>

  <app-sidebar></app-sidebar>
  <div class="sidebar-overlay" (click)="onToggleMobileMenu()"></div>

  <div class="main-content">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>

<app-rightsidebar></app-rightsidebar>
